import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

type BreadcrumbItem = {
    label: string;
    href?: string;
    isActive?: boolean;
};

interface CustomBreadcrumbsProps {
    items: BreadcrumbItem[];
    separator?: React.ReactNode;
    ariaLabel?: string;
}

const CustomBreadcrumbs: React.FC<CustomBreadcrumbsProps> = ({
    items,
    separator = (
        <NavigateNextIcon className={'text-gray-400'} fontSize={'small'} />
    ),
    ariaLabel = 'breadcrumb',
}) => {
    const navigate = useNavigate();

    const handleClick = (path: string) => {
        navigate(path);
    };

    return (
        <nav className={'mb-4'} aria-label={ariaLabel}>
            <ol className={'flex items-center'}>
                {items.map((item, index) => (
                    <React.Fragment key={index}>
                        {index > 0 && (
                            <li
                                className={'mx-2 flex items-center'}
                                aria-hidden={'true'}
                            >
                                {separator}
                            </li>
                        )}
                        <li className={'flex items-center'}>
                            {item.isActive || !item.href ? (
                                <span
                                    className={'text-gray-400 font-medium'}
                                    aria-current={'page'}
                                >
                                    {item.label}
                                </span>
                            ) : (
                                <button
                                    onClick={() => handleClick(item.href!)}
                                    className={`text-[#00A4B1] text-primary 
                                        hover:underline transition-colors
                                        focus:outline-none rounded`}
                                >
                                    {item.label}
                                </button>
                            )}
                        </li>
                    </React.Fragment>
                ))}
            </ol>
        </nav>
    );
};

export default CustomBreadcrumbs;
